import PerfectScrollbar from 'perfect-scrollbar';
jQuery(function ($) {
	if ($('.show-search-result-box').length) {
    var ps = new PerfectScrollbar('.show-search-result-box');
	}
	if ($('.js-pc-aside-student-info').length) {
		const ps = new PerfectScrollbar('.js-pc-aside-student-info', {
			wheelSpeed: 0.5,
			minScrollbarLength: 20,
			scrollingThreshold: 5000,
			suppressScrollX: true,
			swipeEasing: true,
		});
	}
});
